'use client';
import QueryKey from '../utils/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { SHINKAI_NAMESPACES } from '../utils/constants';
import { useAccountChainIdOrDefault } from './useAccountChainIdOrDefault';

export const useGetShinkaiNamespaces = () => {
  const chainId = useAccountChainIdOrDefault();

  return useQuery({
    queryKey: [QueryKey.SHINKAI_NAMESPACES, { chainId }],
    queryFn: () => SHINKAI_NAMESPACES[chainId],
    initialData: {},
  });
};
